var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.posteAVerser.posteAim.libelle))]),_c('td',[_c('v-text-field',{attrs:{"dense":"","hide-details":"","type":"number","value":_vm.posteAVerser.montant},on:{"input":_vm.changerMontantAVerser}})],1),_c('td',[_c(_setup.SInfoMontant,{attrs:{"montant":_vm.montantParVersement}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }